+function ($) {
    'use strict';
    
    var TourSearchForm = function (element, option) {
        this.$form = $(element);
        this.$cityFrom = this.$form.find('#cityFrom');
        this.$countryTo = this.$form.find('#countryTo');
        this.$accommodations = this.$form.find('#accommodations');
        this.$tourTypes = this.$form.find('#tourTypes');
        this.$foodTypes = this.$form.find('#foodTypes');
        this.$hotelClass = this.$form.find('#hotelClass');
        this.$hotelClassBetter = this.$form.find('[name="hotelClassBetter"]');
        this.$hotelsName = this.$form.find('#hotelsName');
        this.$dateFromStart = this.$form.find('#dateFromStart');
        this.$dateFromEnd = this.$form.find('#dateFromEnd');
        this.$amountNightsStart = this.$form.find('#amountNightsStart');
        this.$amountNightsEnd = this.$form.find('#amountNightsEnd');
        this.$priceTo = this.$form.find('#priceTo');
        this.$priceFrom = this.$form.find('#priceFrom');
        this.$foodTypesBetter = this.$form.find('input[name="foodTypesBetter"]');


        this.MIN_PRICE = 0;
        this.MAX_PRICE = 2000000;

        this.DATE_INTERVAL_DAYS = 10;

        this.MAX_CHILD_AGE = 16;

        this.templateHiddenDateOfBirth = '<input type="hidden" name="children[]">';
        this.templateDateOfBirth = '<div class="form-group-row">' +
                                        '<div class="col-lg-3 col-md-3 col-sm-3 col-xsm-3">' +
                                            '<input type="text" placeholder="" name="" class="form-control black"' +
                                            '       autocomplete="off">'+
                                        '</div>' +
                                    '</div>';
        this.popupWindowChildren = '<div class="popup-window" id="datesOfBirth">' +
                                '<div class="container">' +
                                    '<div class="popup-window__close-cross popup-close">x</div>' +
                                    '<h2 class="white">Возраст детей (полных лет)</h2>' +
                                    '<div class="form-horizontal">' +
                                    '</div>' +
                                '</div>' +
                            '</div>';

        this.templateHotel = '<label class="hotel-name__item">' +
                                '<input type="checkbox"> <span></span>' +
                             '</label>';
        this.templateHotelRegion = '<div class="hotel-name__region">' +
                                        '<div class="hotel-name__region__head"></div>' +
                                        '<div class="hotel-name__region__hotels-list"></div>' +
                                   '</div>';

        this.templateHotel_new = '<label class="hotel-name__hotels__item">' +
                                    '<input type="checkbox"> <span></span>' +
                                 '</label>';
        this.templateHotelRegion_new = '<label class="hotel-name__region__item"><input type="checkbox"> <span></span></label>';


        this.popupWindowHotels = '<div class="popup-window" id="hotelsNameWindow">' +
                                    '<div class="container">' +
                                        '<div class="popup-window__close-cross popup-close">x</div>' +
                                        '<h2 class="white">Отели</h2>' +
                                        '<div class="form-horizontal">' +
                                            '<input type="text" class="form-control black" id="nameHotelSearchInput" ' +
                                            '       autocomplete="off" placeholder="Поиск по названию отеля...">' +
                                        '</div>' +
                                        '<div class="data">' +
                                            '<div class="hotel-name__regions"></div>' +
                                            '<div class="hotel-name__hotels"></div>' +
                                        '</div> ' +
                                    '</div>' +
                                 '</div>';

        this.actionBtn = '<div class="form-group-row">' +
                            '<div class="col-lg-1 col-md-1 col-sm-1 col-xsm-1 text-center">'+
                            '</div>'+
                            '<div class="col-lg-1 col-md-1 col-sm-1 col-xsm-1 text-center">'+
                                 '<a href="#" class="btn btn-danger accept">Применить</a>'+
                            '</div>' +
                         '</div>';

        //Описание поведения элементов и отправка формы
        var self = this;
        
        this.$countryTo.bind('change', function () {
            //self.changeCountryFrom();
            self.updateForm('countryTo');
            return true;
        });

        this.$cityFrom.bind('change', function () {
            //self.changeCountryFrom();
            self.updateForm('cityFrom');
            return true;
        });

        this.$accommodations.bind('change', function () {
            self.updateForm('accommodation');
            return true;
        });

        this.$hotelsName.bind('click', function () {
            self.getNameHotels();
            return true;
        });

        this.$hotelClass.bind('change', function () {
            var values = self.$hotelsName.val().split(',');
            var newValue = [];
            for (var i = 0; i < values.length; i++) {
                if (self._filterHotelNameByClassHotel(values[i])) {
                    newValue.push(values[i]);
                } else {
                    values[i] = values[i].replace(/^\s*(.*)\s*$/, '$1');
                    $('input[value="' + values[i] + '"]').removeAttr('checked');
                }
            }
            newValue = newValue.join(',');
            self.$hotelsName.val(newValue);
            return true;
        });
        
        this.$accommodations.bind('change', function () {
            if (self.$accommodations.find('option:selected').data('children') > 0) {
                self.$form.find('input[name="children[]"]').remove();
            }

            //Проверка на выбор параметров типа размещения с детьми
            var $option = self.$accommodations.find('option:selected');
            if (($option.data('children') > 0) && (self.$form.find('input[name="children[]"]').length != $option.data('children'))) {
                $('body').find('#datesOfBirth').remove();
                self.$form.find('input[name="children[]"]').remove();

                $('body').append(self.popupWindowChildren);
                var amountChildren = $option.data('children');
                for (var i = 0; i < amountChildren; i++) {
                    var $childInput = $(self.templateDateOfBirth);
                    $childInput.find('input[type="text"]').attr('name', 'child'+(i+1));
                    $childInput.find('input[type="text"]').attr('placeholder', 'Количество полных лет ребенка '+(i+1));
                    $childInput.find('input[type="text"]').mask('00');
                    $childInput.find('input[type="text"]').bind('change', function () {
                        var age = self.checkChildAge(this);
                        console.log(age);
                        console.log(this);
                        $(this).val(age);
                    });
                    $('body').find('#datesOfBirth').find('.form-horizontal').append($childInput);
                }

                $('body').find('#datesOfBirth').find('.form-horizontal').append(self.actionBtn);
                $('body').find('#datesOfBirth').popupWindow('show');
                $('body').find('#datesOfBirth').find('.accept').bind('click', function () {
                    $('body').find('#datesOfBirth').popupWindow('hide');
                    //Тут код по переносу заполненных данных в форму
                    var datesOfBirth = $('body').find('#datesOfBirth').find('input[type="text"]');
                    for (var i = 0; i < datesOfBirth.length; i++) {
                        if (datesOfBirth.eq(i).val() != '') {
                            //Если не пусто значение забираем его и инициализируем соответстующий инпут в форме
                            self.$form.append('<input type="hidden" name="children[]" value="'+datesOfBirth.eq(i).val()+'">');
                        }
                    }
                });
            }
        });
        
        this.$form.bind('submit', function () {
            var $option = self.$accommodations.find('option:selected');
            if (self.$form.find('input[name="children[]"]').length != $option.data('children')) {
                $('body').find('#datesOfBirth').popupWindow('show');
                return false;
            }
            return true;
        });

        //Тут меняем блок инициализации даты в форме
        var dateStart = null;
        var dateEnd   = null;
        var dateToday = new Date();
        var forCompareDate = null;

        try {
            dateStart = $.DateHelper.strToDate(this.$dateFromStart.val());
            dateEnd   = $.DateHelper.strToDate(this.$dateFromEnd.val());

            forCompareDate = $.DateHelper.strToDate(this.$dateFromStart.val());
            forCompareDate = $.DateHelper.addDaysToDate(this.DATE_INTERVAL_DAYS, forCompareDate);

            if($.DateHelper.compareDates(dateStart, dateToday) == -1) throw 'Interval dates of flying is not correct';
            if($.DateHelper.compareDates(dateStart, dateEnd) == 1) throw 'Interval dates of flying is not correct';

            switch ($.DateHelper.compareDates(dateEnd, forCompareDate)) {
                case 1:
                    throw 'Interval dates of flying is not correct';
                    break;
            }
        } catch (err) {
            dateStart = new Date();
            dateEnd = $.DateHelper.addDaysToDate(this.DATE_INTERVAL_DAYS, dateStart);
            forCompareDate = $.DateHelper.addDaysToDate(this.DATE_INTERVAL_DAYS, dateStart);
        }


        this.$dateFromStart.datepicker().data('datepicker').selectDate(dateStart);
        this.$dateFromEnd.datepicker({
            minDate: dateStart,
            maxDate: forCompareDate,
            onSelect: function (formattedDate, date, inst) {
                inst.hide();
            }
        });
        this.$dateFromEnd.datepicker().data('datepicker').selectDate(dateEnd);

        this.$dateFromStart.datepicker({
            minDate: dateToday,
            onSelect: function (formattedDate, date, inst) {
                var selectedDate = date;
                var endOfIntervalDate = $.DateHelper.addDaysToDate(self.DATE_INTERVAL_DAYS, selectedDate);
                var currentEndDate    = $.DateHelper.strToDate(self.$dateFromEnd.val());

                if ($.DateHelper.compareDates(currentEndDate, selectedDate) == -1
                    || $.DateHelper.compareDates(currentEndDate, endOfIntervalDate) == 1) {
                    currentEndDate = endOfIntervalDate;
                    self.$dateFromEnd.datepicker().data('datepicker').selectDate(currentEndDate);
                }

                var datepicker = self.$dateFromEnd.datepicker().data('datepicker');
                datepicker.update({
                    minDate: selectedDate,
                    maxDate: endOfIntervalDate,
                });

                inst.hide();
            }
        });







        if (   !$.NumberHelper.isInt(this.$amountNightsStart.val())
            || !$.NumberHelper.isInt(this.$amountNightsEnd.val())
            || $.NumberHelper.asInt(this.$amountNightsStart.val()) < 0
            || $.NumberHelper.asInt(this.$amountNightsEnd.val())   < $.NumberHelper.asInt(this.$amountNightsStart.val())
            || $.NumberHelper.asInt(this.$amountNightsEnd.val())   <= 0
            || $.NumberHelper.asInt(this.$amountNightsEnd.val())   > 30) {
            this.$amountNightsStart.val('1');
            this.$amountNightsEnd.val('6');
        }

        this.$amountNightsStart.bind('change', function () {
            //Проверка на допустимость значений
            if (   $.NumberHelper.isInt(self.$amountNightsStart.val())
                && $.NumberHelper.asInt(self.$amountNightsStart.val()) > 0) {
                //Проверка значения в поле от
                var amountNightEnd = $.NumberHelper.asInt(self.$amountNightsEnd.val());
                var amountNightSart = $.NumberHelper.asInt(self.$amountNightsStart.val());
                if (amountNightSart > amountNightEnd) {
                    amountNightEnd = amountNightSart+1;
                    self.$amountNightsEnd.val(amountNightEnd);
                }
            } else {
                self.$amountNightsStart.val('1');
                return true;
            }
        });
        
        this.$amountNightsEnd.bind('change', function () {
            if (   $.NumberHelper.isInt(self.$amountNightsEnd.val())
                && $.NumberHelper.asInt(self.$amountNightsEnd.val()) <= 30) {
                //Проверка значения в поле до
                var amountNightStart = $.NumberHelper.asInt(self.$amountNightsStart.val());
                var amountNightEnd = $.NumberHelper.asInt(self.$amountNightsEnd.val());
                if (amountNightStart > amountNightEnd) {
                    amountNightEnd = amountNightSart+1;
                    self.$amountNightsEnd.val(amountNightEnd);
                }
            } else {
                self.$amountNightsEnd.val($.NumberHelper.asInt(self.$amountNightsStart.val())+1);
                return true;
            }
        });

        if (   !$.NumberHelper.isInt(this.$priceFrom.val())
            || !$.NumberHelper.isInt(this.$priceTo.val())
            || $.NumberHelper.asInt(this.$priceFrom.val()) > $.NumberHelper.asInt(this.$priceTo.val())
            || $.NumberHelper.asInt(this.$priceFrom.val()) < this.MIN_PRICE
            || $.NumberHelper.asInt(this.$priceTo.val())   > this.MAX_PRICE) {
            this.$priceFrom.val(this.MIN_PRICE);
            this.$priceTo.val(this.MAX_PRICE);
        }

        this.$priceFrom.bind('change', function () {
            try {
                var priceFrom = $.NumberHelper.asInt(self.$priceFrom.val());
                var priceTo = $.NumberHelper.asInt(self.$priceTo.val());
            } catch (err) {
                priceFrom = self.MIN_PRICE;
                priceTo = self.MAX_PRICE;
            }

            if ((priceFrom < self.MIN_PRICE) || (priceFrom > priceTo)) {
                self.$priceFrom.val(self.MIN_PRICE);
            }
        });
        
        this.$priceTo.bind('change', function () {
            try {
                var priceFrom = $.NumberHelper.asInt(self.$priceFrom.val());
                var priceTo = $.NumberHelper.asInt(self.$priceTo.val());
            } catch (err) {
                priceFrom = self.MIN_PRICE;
                priceTo = self.MAX_PRICE;
            }

            if ((priceTo < priceFrom) || (priceTo > self.MAX_PRICE)) {
                self.$priceTo.val(self.MAX_PRICE);
            }
        });
    };

    /**
     * Возвращает проверенное и модифицированное количество
     * лет для ребенка. В тех случаях когда возвраст ребенка вне границ
     * возвращает 0 лет.
     * @param input
     * @return {*}
     */
    TourSearchForm.prototype.checkChildAge = function (input) {
        var age = $(input).val();
        if (!isNaN(parseInt(age)) && age > 0 && age <= this.MAX_CHILD_AGE) {
            return parseInt(age);
        }

        return 0;
    };
    
    TourSearchForm.prototype.getNameHotels = function() {
        var countryTo = this.$countryTo.val();
        var cityFrom = this.$cityFrom.val();
        var renew = false;
        try {
            if (this.cache['getNameHotels']['countryTo'] !== countryTo ||
                this.cache['getNameHotels']['cityFrom'] !== cityFrom) {
                renew = true;
                this.cache['getNameHotels']['countryTo'] = countryTo;
                this.cache['getNameHotels']['cityFrom'] = cityFrom;
            }
        } catch (err) {
            renew = true;
            this.cache = {'getNameHotels' : {'countryTo' : countryTo, 'cityFrom' : cityFrom}}
        }

        if (renew) {
            var token = this.$form.find('[name="_token"]').val();
            $('#hotelsNameWindow').remove();
            $.ajax({
                url: '/tours/name_hotels',
                method: 'post',
                data: 'cityFrom='+cityFrom+'&countryTo='+countryTo+'&_token='+token,
                cache: false,
                context: this,
                dataType: 'json',
                beforeSend: function() {
                    this.$form.animate({
                        opacity: 0.5,
                    }, {
                        duration: 400,
                        easing: 'swing',
                    });
                },
                success: function (data) {
                    this.$form.animate({
                        opacity: 1,
                    }, {
                        duration: 400,
                        easing: 'swing',
                    });
                    var self = this;
                    var $popupWindow;
                    if ($('#hotelsNameWindow').length == 0) {
                        $popupWindow = $(this.popupWindowHotels);
                        for(var i = 0; i < data.length; i++) {
                            var $hotelsInRegion = data[i];
                            var $regionItem = $(this.templateHotelRegion_new);
                            var $hotelsList = $popupWindow.find('.hotel-name__hotels');
                            $regionItem.find('span').text($hotelsInRegion['regionName']);
                            $regionItem.bind('click', function (ev) {
                                ev.preventDefault();

                                var regionId = $(this).data('region_id');
                                if ($(this).hasClass('selected')) {
                                    $(this).removeClass('selected');
                                    $(this).find('input').prop('checked', false);
                                    var $hotels = $popupWindow.find('.hotel-name__hotels__item[data-region_id="'+regionId+'"]');
                                    $hotels.removeClass('showed');
                                    $hotels.find('input').prop('checked', false);
                                    // какие-то действия для скрытия и сброса всех отелей в данном регионе
                                } else {
                                    $(this).addClass('selected');
                                    $(this).find('input').prop('checked', true);
                                    var $hotels = $popupWindow.find('.hotel-name__hotels__item[data-region_id="'+regionId+'"]');
                                    $hotels.addClass('showed');
                                    // какие-то действия для отображения всех отелей в данном регионе
                                }
                            });
                            $popupWindow.find('.hotel-name__regions').append($regionItem);
                            $regionItem.attr('data-region_id', i);

                            for(var j = 0; j < $hotelsInRegion['hotelsName'].length; j++) {
                                var $hotelItem = $(this.templateHotel_new);
                                $hotelItem.find('input').val($hotelsInRegion['hotelsName'][j]);
                                $hotelItem.find('span').text($hotelsInRegion['hotelsName'][j]);
                                $hotelItem.attr('data-region_id', i);
                                $hotelsList.append($hotelItem);
                            }
                        }

                        $popupWindow.find('.hotel-name__hotels input').bind('change', function () {
                            self._addHotelName($popupWindow.find('.hotel-name__hotels input:checked'));
                        });

                        $('body').append($popupWindow);
                    } else {
                        $popupWindow = $('#hotelsNameWindow');
                    }

                    $popupWindow.popupWindow('show');
                    this._synchronizeHotels($popupWindow);
                    var $inputs = $('#hotelsNameWindow .hotel-name__hotels').find('input[type="checkbox"]');
                    var self = this;
                    $inputs.each(function() {
                        if (!self._filterHotelNameByClassHotel($(this).val())) {
                            $(this).parent().removeClass('showed');
                        } else {
                            $(this).parent().addClass('showed');
                        }
                    });

                    $popupWindow.find('#nameHotelSearchInput').unbind('keyup');
                    $popupWindow.find('#nameHotelSearchInput').bind('keyup', function() {
                        self.findHotelNameCoincidence($(this).val(), $popupWindow);
                    });

                    //после того как все необходимые манипуляции были сделаны нужно скрыть те регионы
                    // которые оказались пустыми
                    self.toggleRegionPanles();
                }
            });
        } else {
            var $popupWindow = $('#hotelsNameWindow');
            $popupWindow.popupWindow('show');
            this._synchronizeHotels($popupWindow);
        }

        var $inputs = $('#hotelsNameWindow .hotel-name__hotels').find('input[type="checkbox"]');
        var self = this;
        $inputs.each(function() {
            if (!self._filterHotelNameByClassHotel($(this).val())) {
                $(this).parent().removeClass('showed');
            } else {
                $(this).parent().addClass('showed');
            }
        });

        //после того как все необходимые манипуляции были сделаны нужно скрыть те регионы
        // которые оказались пустыми
        self.toggleRegionPanles();
    };

    /**
     * Проверяет наличие регионов в которых нет названий отелей и скрывает их
     */
    TourSearchForm.prototype.toggleRegionPanles = function () {
        var $regions = $('#hotelsNameWindow').find('.hotel-name__region__item');
        for (var i = 0; i < $regions.length; i++) {
            var region_id = $regions.eq(i).data('region_id');
            var $hotels = $('#hotelsNameWindow').find('.hotel-name__hotels__item[data-region_id="'+region_id+'"]');
            var hiddenAmount = 0;
            for (var j = 0; j < $hotels.length; j++) {
                if (!$hotels.eq(j).hasClass('showed')) {
                    hiddenAmount++;
                }
            }
            if ($hotels.length == hiddenAmount) {
                //все отели скрыты
                $regions.eq(i).css('display', 'none').removeClass('selected').find('input[type=checkbox]').prop('checked', false);
            } else {
                $regions.eq(i).css('display', 'block').addClass('selected').find('input[type=checkbox]').prop('checked', true);
            }
        }
    };
    
    TourSearchForm.prototype.findHotelNameCoincidence = function(word, $container) {
        if (this.onfindHotelNameCoincidence) {
            return false;
        } else {
            this.onfindHotelNameCoincidence = true;
        }
        word = ''+word;
        word = word.toLowerCase();
        if (!this.searchHotelNameWordLength) {
            this.searchHotelNameWordLength = word.length;
        }
        var $hotels = null;
        if (this.searchHotelNameWordLength > word.length) {
            var self = this;
            // фильтруем все имена отелей относительно установленного класса отеля
            $hotels = $container.find('.hotel-name__hotels__item input[type="checkbox"]').filter(function (index) {
                return self._filterHotelNameByClassHotel($(this).val());
            });
        } else {
            $hotels = $container.find('.hotel-name__hotels__item.showed input[type="checkbox"]');
        }
        this.searchHotelNameWordLength = word.length;

        for (var i = 0; i < $hotels.length; i++) {
            var str = $hotels[i].value.toLowerCase().substring(0, word.length);
            if (str.indexOf(word) >= 0) {
                $hotels.eq(i).parent().addClass('showed');
            } else {
                $hotels.eq(i).parent().removeClass('showed');
            }
        }
        this.toggleRegionPanles();
        this.onfindHotelNameCoincidence = false;
    };

    TourSearchForm.prototype._synchronizeHotels = function ($container) {
        var selectedHotels = this.$hotelsName.val().split(',');
        for (var i = 0; i < selectedHotels.length; i++) {
            selectedHotels[i] = selectedHotels[i].replace(/^\s*(.*)\s*$/, '$1');
            $container.find('[value="' + selectedHotels[i] + '"]').prop('checked', true).attr('checked', 'checked');
        }
    };

    TourSearchForm.prototype._filterHotelNameByClassHotel = function (name) {
        // приведем название отеля к единому техническому виду без пробелов
        name = name.replace(/\s+/g, '');
        var ALL_CLASSES = [];
        this.$hotelClass.find('option').each(function () {
            // приводим все варианты отелей к единому техническому виду без пробелов
            ALL_CLASSES.push($(this).val().replace(/\s+/g, ''));
        });

        // выберем текущий класс, не забудем о том что его нужно привести в общий технический вид
        var currentHotelClass = this.$hotelClass.val().replace(/\s+/g, '');
        // найдем место текущего класса в массиве классов
        var start_pos = ALL_CLASSES.indexOf(currentHotelClass);
        if (start_pos > ALL_CLASSES.length) start_pos = 0;

        if (this.$hotelClassBetter.prop('checked')) {
            // Проверим соответствие параметра name требованиям отображения (если стоит галочка и лучше)
            for (var i = start_pos; i < ALL_CLASSES.length; i++) {
                if (name.indexOf(ALL_CLASSES[i]) != -1) {
                    return true;
                }
            }
        } else {
            // проверяем на строгое соответствие
            if (name.indexOf(ALL_CLASSES[start_pos]) != -1) {
                return true;
            }
        }


        return false;
    };

    TourSearchForm.prototype._addHotelName = function ($inputs) {
        var value;
        for(var i = 0; i < $inputs.length; i++) {
            if (!value) {
                value = $inputs.eq(i).val();
            } else {
                value = value + ', ' + $inputs.eq(i).val();
            }
        }
        this.$hotelsName.val(value);
    };

    TourSearchForm.prototype.updateForm = function (element) {
        var countryTo = this.$countryTo.val();
        var cityFrom = this.$cityFrom.val();
        var accommodation = this.$accommodations.val();
        var dateFromStart = this.$dateFromStart.val();
        var dateFromEnd = this.$dateFromEnd.val();
        var amountNightsStart = this.$amountNightsStart.val();
        var amountNightsEnd = this.$amountNightsEnd.val();

        this._updateFormElementChanged = element;
        var token = this.$form.find('[name="_token"]').val();
        var loaderTmpl = '<div class="form-loader"></div>';
        $.ajax({
            url: '/',
            method: 'post',
            data: 'countryTo=' + countryTo + '&cityFrom=' + cityFrom + '&accommodation=' + accommodation +
            '&dateBegin=' + dateFromStart + '&dateEnd=' + dateFromEnd + '&amountNightsStart=' + amountNightsStart +
            '&amountNightsEnd=' + amountNightsEnd + '&_token=' + token,
            cache: false,
            context: this,
            dataType: 'json',
            beforeSend: function (xhr) {
                this.$form.find('[type="submit"]').addClass('disabled');
                this.$form.find('input, select').attr('disabled', 'disabled').prop('disabled', true);

                var self = this;
                this.$form.animate({
                    'opacity': 0.5,
                }, {
                    'duration': 400,
                    'easing': 'swing',
                    'complete': function () {
                        self.$form.append(loaderTmpl);
                    }
                });
            },
            success: function (data) {
                switch (this._updateFormElementChanged) {
                    case 'cityFrom':
                        this.$countryTo.empty();
                        if (data.countriesTo.length > 0) {
                            for (var i = 0; i < data.countriesTo.length; i++) {
                                this.$countryTo.append('<option value="' + data.countriesTo[i] + '">' + data.countriesTo[i] + '</option>');
                            }

                            this.$countryTo.find('option[value="' + countryTo + '"]').attr('selected', 'selected').prop('selected', true);
                        }

                        this.$accommodations.empty();
                        if (data.accommodations.length > 0) {
                            for (var i = 0; i < data.accommodations.length; i++) {
                                this.$accommodations.append(data.accommodations[i]);
                            }

                            this.$accommodations.find('option[value="' + accommodation + '"]').attr('selected', 'selected').prop('selected', true);
                        }

                        this.$foodTypes.empty();
                        for (var i = 0; i < data.rAndBs.length; i++) {
                            this.$foodTypes.append(data.rAndBs[i]);
                        }

                        this.$hotelClass.empty();
                        for (var i = 0; i < data.hotelClasses.length; i++) {
                            this.$hotelClass.append(data.hotelClasses[i]);
                        }

                        this.$tourTypes.empty();
                        for (var i = 0; i < data.tourTypes.length; i++) {
                            this.$tourTypes.append(data.tourTypes[i]);

                        }
                        break;

                    case 'countryTo':
                        this.$accommodations.empty();
                        if (data.accommodations.length > 0) {
                            for (var i = 0; i < data.accommodations.length; i++) {
                                this.$accommodations.append(data.accommodations[i]);
                            }

                            this.$accommodations.find('option[value="' + accommodation + '"]').attr('selected', 'selected').prop('selected', true);
                        }

                        this.$foodTypes.empty();
                        for (var i = 0; i < data.rAndBs.length; i++) {
                            this.$foodTypes.append(data.rAndBs[i]);
                        }

                        this.$hotelClass.empty();
                        for (var i = 0; i < data.hotelClasses.length; i++) {
                            this.$hotelClass.append(data.hotelClasses[i]);
                        }

                        this.$tourTypes.empty();
                        for (var i = 0; i < data.tourTypes.length; i++) {
                            this.$tourTypes.append(data.tourTypes[i]);

                        }
                        break;
                    case 'accommodation':
                        this.$foodTypes.empty();
                        for (var i = 0; i < data.rAndBs.length; i++) {
                            this.$foodTypes.append(data.rAndBs[i]);
                        }

                        this.$hotelClass.empty();
                        for (var i = 0; i < data.hotelClasses.length; i++) {
                            this.$hotelClass.append(data.hotelClasses[i]);
                        }

                        this.$tourTypes.empty();
                        for (var i = 0; i < data.tourTypes.length; i++) {
                            this.$tourTypes.append(data.tourTypes[i]);

                        }
                        break;
                }

                this.$form.find('[type="submit"]').removeClass('disabled');

                this.$hotelsName.val('');

                this.$form.find('.form-loader').remove();
                this.$form.find('input, select').removeAttr('disabled', 'disabled').prop('disabled', false);

                this.$form.animate({
                    'opacity': 1,
                }, {
                    'duration': 400,
                    'easing': 'swing',
                });
            }

        });
    };
    
    TourSearchForm.prototype.changeCountryFrom = function () {
        var countryTo = this.$countryTo.val();
        var cityFrom = this.$cityFrom.val();
        var accommodation = this.$accommodations.val();
        var dateFromStart = this.$dateFromStart.val();
        var token = this.$form.find('[name="_token"]').val();
        var loaderTmpl = '<div class="form-loader"></div>';
        $.ajax({
            url: '/',
            method: 'post',
            data: 'countryTo=' + countryTo + '&cityFrom=' + cityFrom + '&accommodation=' + accommodation +
                '&dateBegin=' + dateFromStart + '&_token=' + token,
            cache: false,
            context: this,
            dataType: 'json',
            beforeSend: function (xhr) {
                this.$form.find('[type="submit"]').addClass('disabled');
                this.$form.find('input, select').attr('disabled', 'disabled').prop('disabled', true);

                var self = this;
                this.$form.animate({
                    'opacity': 0.5,
                }, {
                    'duration': 400,
                    'easing': 'swing',
                    'complete': function () {
                        self.$form.append(loaderTmpl);
                    }
                });
            },
            success: function (data) {
                this.$accommodations.empty();
                if (data.countriesTo.length > 0) {
                    this.$countryTo.empty();
                    for (var i = 0; i < data.countriesTo.length; i++) {
                        this.$countryTo.append('<option value="' + data.countriesTo[i] + '">' + data.countriesTo[i] + '</option>');
                    }

                    this.$countryTo.find('option[value="' + countryTo + '"]').attr('selected', 'selected').prop('selected', true);
                }

                if (data.accommodations.length > 0) {
                    for (var i = 0; i < data.accommodations.length; i++) {
                        this.$accommodations.append(data.accommodations[i]);
                    }

                    this.$accommodations.find('option[value="' + accommodation + '"]').attr('selected', 'selected').prop('selected', true);
                } else {
                    // вывод сообщения о том что по выбранному напралению туры из указанного города вылета недоступны

                }


                this.$foodTypes.empty();
                for (var i = 0; i < data.rAndBs.length; i++) {
                    this.$foodTypes.append(data.rAndBs[i]);
                }

                this.$hotelClass.empty();
                for (var i = 0; i < data.hotelClasses.length; i++) {
                    this.$hotelClass.append(data.hotelClasses[i]);
                }

                this.$tourTypes.empty();
                for (var i = 0; i < data.tourTypes.length; i++) {
                    this.$tourTypes.append(data.tourTypes[i]);
                }

                this.$form.find('[type="submit"]').removeClass('disabled');

                this.$hotelsName.val('');

                this.$form.find('.form-loader').remove();
                this.$form.find('input, select').removeAttr('disabled', 'disabled').prop('disabled', false);

                this.$form.animate({
                    'opacity': 1,
                }, {
                    'duration': 400,
                    'easing': 'swing',
                });
            }

        });
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            return new TourSearchForm(this, options)
        });
    };



    var old = $.fn.toursearchform;

    $.fn.toursearchform = constructor;
    $.fn.toursearchform.constructor = constructor;

    $.fn.toursearchform.noConflict = function () {
        $.fn.toursearchform = old;
        return this;
    }
}(jQuery);
    
    
$(document).ready(function () {
    $('[data-toggle="tourSearchForm"]').toursearchform();
});